// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gantt-connector-toolbar_wrapper__Z5jy_","toolbarActions":"gantt-connector-toolbar_toolbarActions__B1bXL","remove":"gantt-connector-toolbar_remove__ZzRJt"};